import { Oauth2Service } from "@/services/oauth2"
import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

export function ConsentPage(){
    const [query] = useSearchParams()

    useEffect(()=>{
        const challenge = query.get("consent_challenge")
        console.log("challenge", challenge)
        if(challenge){
            handleChallenge(challenge)
        }

    },[])

    async function handleChallenge(challenge : string){
        const redirect_url = await Oauth2Service.consent(challenge)
        window.location.href = redirect_url

    }

    return (
        <>
            <p>consent</p>
        </>
    )

}